import { IRGSFreePlayModel } from '@bg-shared/business/RGSFreePlay/interfaces';

export const rgsFreePlaySelectors = {
    selectCountLeft: (state: IRGSFreePlayModel): number => state.available[0]?.count ?? 0,

    selectTotalWin: (state: IRGSFreePlayModel): number => state.info?.won ?? 0,
};
